import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getWebsitesStepByStep(tenant: Tenant): InfoCardProps[] {
	return [
		{
			desc: "Na úvod zhodnotíme vaši situaci, podle toho navrhneme konkrétní kroky. Nemůžete si dovolit vývoj od A do Z s analýzami a průzkumy? sp[[Žádný problém, řešení přizpůsobíme vašemu rozpočtu.]]",
		},
		{
			desc: "Pustíme se do návrhu, vývoje webu a tvorby obsahu – texty a další obsah zajistíme my, nebo ho můžete dodat sami). sp[[Pracujeme v tzv. sprintech, díky kterým je práce efektivní, jednotlivé kroky na sebe navazují.]] Klademe důraz na rychlost stránek, vyladění UX/UI nebo technické SEO.",
		},
		{
			desc: "sp[[Ve smluveném termínu vytvoříme MVP]] (Minimum viable product – web, který splňuje primární cíle, je spustitelný a životaschopný). Na základě MVP můžeme web dále rozvíjet.",
		},
		{
			desc: "V dalším kroku probíhá sp[[testování a nasazení webu.]]",
		},
		{
			desc: "Po spuštění stránek vám budeme k ruce s jejich sp[[podporou a údržbou.]]",
		},
	];
}
